module.exports = __webpack_public_path__ + "static/media/14.7a6e7b2d.jpg";